












import { Component, Vue } from 'vue-property-decorator'
import { emitEvent, AxEventType, registerEvent, unregisterEvent } from '@aspenware-library/event-hub'

@Component
export default class AdminProductSettingsSaveButton extends Vue {
  private inProgress: number = 0
  private successful: number = 0
  private failed: number = 0

  mounted() {
    registerEvent<string>(AxEventType.AdminProductSettingsSaveStatus, this.onSaveStatusChanged)
  }

  beforeDestroy() {
    unregisterEvent(AxEventType.AdminProductSettingsSaveStatus, this.onSaveStatusChanged)
  }

  // Methods
  public save() {
    this.reset()
    emitEvent(AxEventType.AdminProductSettingsUpdate, {})
  }

  private reset() {
    this.inProgress = 0
    this.successful = 0
    this.failed = 0
  }

  private onSaveStatusChanged(event?: string) {
    if (event == 'in-progress') {
      this.inProgress += 1
    } else if (event == 'success') {
      this.successful += 1
      this.inProgress -= 1
    } else if (event == 'failed') {
      this.failed += 1
      this.inProgress -= 1
    }
  }

  get isLoading() {
    return this.inProgress > 0
  }

  get isComplete() {
    return this.inProgress == 0 && (this.successful > 0 || this.failed > 0)
  }

  get didFail() {
    return this.isComplete && this.failed > 0
  }
}
